import React from 'react';
export const OptionPullDown = (props) => {

    const option = props.data ? props.data.map((value, index) =>
        <option key={index} value={value.id} disabled={value.disabled ? value.disabled : false}>
            {value.value}
        </option>
    ) : <></>;
    return (
        <>
            {props.defaultValue ?
                <select
                    className={props.selectClass}
                    onChange={props.onChange}
                    id={props.id}
                    defaultValue={props.defaultValue}
                    disabled={props.disabled}>
                    {option}
                </select>
                :
                <select
                    className={props.selectClass}
                    value={props.value}
                    onChange={props.onChange}
                    id={props.id}
                    disabled={props.disabled}>
                    {option}
                </select>
            }
        </>
    );
}